import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "qp-header" }
const _hoisted_2 = { class: "qp-header-left" }
const _hoisted_3 = { class: "qp-system-name" }
const _hoisted_4 = {
  key: 0,
  class: "qp-user"
}
const _hoisted_5 = { class: "qp-main" }
const _hoisted_6 = {
  key: 0,
  class: "qp-state"
}
const _hoisted_7 = {
  key: 1,
  class: "qp-state qp-state--error"
}
const _hoisted_8 = {
  key: 0,
  class: "qp-card qp-intro"
}
const _hoisted_9 = { class: "qp-title" }
const _hoisted_10 = {
  key: 0,
  class: "qp-desc"
}
const _hoisted_11 = { class: "qp-facts" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "qp-cat-list"
}
const _hoisted_14 = { class: "qp-cat-num" }
const _hoisted_15 = { class: "qp-cat-name" }
const _hoisted_16 = { class: "qp-cat-count" }
const _hoisted_17 = {
  key: 0,
  class: "qp-welcome"
}
const _hoisted_18 = { class: "qp-field" }
const _hoisted_19 = { class: "qp-label-row" }
const _hoisted_20 = ["maxlength"]
const _hoisted_21 = {
  key: 1,
  class: "qp-error"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 2,
  class: "qp-error"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "qp-quiz-head" }
const _hoisted_26 = { class: "qp-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizRunner = _resolveComponent("QuizRunner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "qp-shell",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "qp-logo-mark" }, null, -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.meta?.systemName || 'Obra Tycoon'), 1)
      ]),
      (_ctx.participantName && _ctx.stage !== 'name')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none"
            }, [
              _createElementVNode("circle", {
                cx: "6",
                cy: "4.5",
                r: "2.2",
                stroke: "currentColor",
                "stroke-width": "1.2"
              }),
              _createElementVNode("path", {
                d: "M2 11c0-2.21 1.79-4 4-4s4 1.79 4 4",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round"
              })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.participantName), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("main", _hoisted_5, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "qp-spinner" }, null, -1),
            _createElementVNode("p", null, "Carregando questionário…", -1)
          ]))]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none"
              }, [
                _createElementVNode("circle", {
                  cx: "20",
                  cy: "20",
                  r: "18",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }),
                _createElementVNode("path", {
                  d: "M20 12v10M20 27v2",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.meta)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.stage === 'name')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                      _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.meta.title), 1),
                      (_ctx.meta.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.meta.description), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.meta.questionCount) + " pergunta" + _toDisplayString(_ctx.meta.questionCount === 1 ? '' : 's'), 1),
                        (_ctx.meta.categories.length > 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "· " + _toDisplayString(_ctx.meta.categories.length) + " etapas", 1))
                          : _createCommentVNode("", true),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "· múltipla escolha", -1))
                      ]),
                      (_ctx.meta.categories.length > 1)
                        ? (_openBlock(), _createElementBlock("ol", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.categories, (c, i) => {
                              return (_openBlock(), _createElementBlock("li", { key: i }, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(i + 1), 1),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(c.name), 1),
                                _createElementVNode("span", _hoisted_16, _toDisplayString(c.questionCount) + " pergunta" + _toDisplayString(c.questionCount === 1 ? '' : 's'), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("form", {
                        class: "qp-name-form",
                        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)), ["prevent"]))
                      }, [
                        (_ctx.savedName && _ctx.participantName === _ctx.savedName)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                              _cache[7] || (_cache[7] = _createTextVNode(" Bem-vindo de volta! Você vai responder como ", -1)),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.savedName), 1),
                              _cache[8] || (_cache[8] = _createTextVNode(" — altere abaixo se quiser. ", -1))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("label", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "qp-label" }, "Nome de usuário", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass(["qp-counter", { 'qp-counter--max': _ctx.participantName.length >= _ctx.NAME_MAX }])
                            }, _toDisplayString(_ctx.participantName.length) + "/" + _toDisplayString(_ctx.NAME_MAX), 3)
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            ref: "nameInputRef",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.participantName) = $event)),
                            class: "qp-input",
                            maxlength: _ctx.NAME_MAX,
                            autocomplete: "name",
                            placeholder: "Como você quer ser identificado"
                          }, null, 8, _hoisted_20), [
                            [_vModelText, _ctx.participantName]
                          ])
                        ]),
                        (_ctx.startError)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.startError), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "qp-btn",
                          type: "submit",
                          disabled: _ctx.starting || _ctx.meta.questionCount === 0
                        }, _toDisplayString(_ctx.starting ? 'Preparando…' : 'Começar questionário'), 9, _hoisted_22),
                        (_ctx.meta.questionCount === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Este questionário ainda não tem perguntas."))
                          : _createCommentVNode("", true)
                      ], 32)
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.meta.title), 1)
                      ]),
                      _createVNode(_component_QuizRunner, {
                        categories: _ctx.categories,
                        "current-index": _ctx.currentIndex,
                        result: _ctx.result,
                        submitting: _ctx.submitting,
                        "participant-name": _ctx.participantName,
                        onSubmitCategory: _ctx.submitCategory,
                        onRestart: _ctx.start
                      }, null, 8, ["categories", "current-index", "result", "submitting", "participant-name", "onSubmitCategory", "onRestart"])
                    ]))
              ], 64))
            : _createCommentVNode("", true)
    ])
  ], 4))
}